export const FilterGradienIcon = (props) => (
  <svg
    {...props}
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.56714 1L1.56714 6L6.56714 11"
      stroke="url(#paint0_linear_4077_26019)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4077_26019"
        x1="4.06697"
        y1="1"
        x2="4.06697"
        y2="11.0005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000000" />
        <stop offset="1" stopColor="#000000" />
      </linearGradient>
    </defs>
  </svg>
);
